export default [
  {
    path: 'board',
    name: 'oldBoard',
    component: () => import('@/views/Factory/Board/Board.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'oldBoard',
      template: 'auth',
    },
  },
  {
    path: 'board-overview',
    name: 'board',
    component: () => import('@/views/Factory/Board/Board.vue'),
    props: true,
    meta: {
      middleware: 'auth',
      name: 'board',
      template: 'auth',
    },
  },
];
